import { Head } from "@inertiajs/react"
import { NativeNavbar } from "@ruby-native/react"

import AppLayout from "@/layouts/app-layout"
import { newRecipePath, recipesPath } from "@/routes"
import type { BreadcrumbItem, RecipeImportData } from "@/types"

import RecipeForm from "./Form"

const breadcrumbs: BreadcrumbItem[] = [
  { title: "Recipes", href: recipesPath() },
  { title: "New Recipe", href: newRecipePath() },
]

interface Props {
  import_data: RecipeImportData | null
  import_id: number | null
}

export default function New({ import_data, import_id }: Props) {
  const action = import_id
    ? `${recipesPath()}?import_id=${import_id}`
    : recipesPath()

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <NativeNavbar title="New Recipe" />
      <Head title="New Recipe" />
      <RecipeForm action={action} method="post" importData={import_data} />
    </AppLayout>
  )
}
